export function gatheringInfoNoticeMessage(project: {
  name?: string;
  id?: number;
  gather_project_info?: boolean;
  research_start_warning?: string;
  research_jobs?: unknown[];
  research_job?: unknown;
}): string | null {
  if (!project.gather_project_info) {
    return null;
  }
  const started =
    (Array.isArray(project.research_jobs) && project.research_jobs.length > 0) ||
    Boolean(project.research_job);
  if (!started) {
    return null;
  }
  const name = (project.name || '').trim() || `Project #${project.id}`;
  const count = Array.isArray(project.research_jobs) ? project.research_jobs.length : 1;
  if (count > 1) {
    return `We are gathering info about ${name} (${count} markets)`;
  }
  return `We are gathering info about ${name}`;
}
